import { gql } from "@apollo/client";

export const CREATE_SUSPENSION = gql`
    mutation CreateSuspension(
        $idSuspension: Int!, 
        $idEvaluacion: Int!,
        $idPaciente: Int!,
        $soloContrato: Boolean!,
        $idDelegacion: Int!,
        $idMotivo: Int!,
        $observacion: String,
        $fechaDesde: CustomDateTime!,
        $fechaHasta: CustomDateTime!,
        $fechaObito: CustomDateTime,
        $idDetalleObito: Int
    ) {
        createSuspension(
            input: {
                idSuspension:$idSuspension,
                idEvaluacion:$idEvaluacion,
                idPaciente: $idPaciente,
                soloContrato: $soloContrato,
                idDelegacion: $idDelegacion,
                idMotivo: $idMotivo,
                observacion: $observacion,
                fechaDesde: $fechaDesde,
                fechaHasta: $fechaHasta,
                fechaObito: $fechaObito
                idDetalleObito: $idDetalleObito
            }
        ) {
            success
            error
        }
    }
`;